import { useWorker } from "../../../../../../Hooks/useWorker";
import RepositoryPicker from "../../../../../UI/Specialized/RSRepositoryPicker";
import { allDeSelectId, allSelectId } from "../../Actions/c365fullRepoChange";

const RepositoryPkr = ({useCloud}) => { 
  const { working } = useWorker(allSelectId)
  const { working:w2} = useWorker(allDeSelectId)

  let disabled = working || w2;

  return <RepositoryPicker clearOnUnmount {...{useCloud, disabled}}/>;
};

export default RepositoryPkr;
